import { useCustomComponentRendered } from "../observer/useDomObserver";
import useMap from "../utils/useMap";
import useFetchZone from "./useFetchZone";

const useCustomComponent = (() => {

    const componentPoolBySrc = useMap(),
        componentPoolByName = useMap();


    /**
     * Description placeholder
     *
     * @param {HTMLElement} elem
     * @returns {boolean}
     */
    const isNotInTemplate = (elem) => {
        return document.body.contains(elem);
    }

    const compRendered = new Set();

    const newComponent = (name, onRendered) => {
        const component = (function () {
            return class extends HTMLElement {

                abortController = { abort: () => { } };


                constructor() {
                    super();
                }

                get hasRendered() {
                    return this.children.length > 0;
                }

                connectedCallback() {
                    if (!compRendered.has(this) && isNotInTemplate(this)) {
                        onRendered({ name, node: this, abortController: this.abortController })
                    }
                    compRendered.add(this);
                }

                disconnectedCallback() {
                    this.abortController.abort();
                }
            }
        })();
        window.customElements.define(name, component);
        return component;
    }

    const defineComponent = ({
        src, name = ''
    }) => {
        if (componentPoolBySrc.has(src)) {
            return;
        } else if (componentPoolByName.has(src)) {
            console.log(`The "${name}" name already used`)
            return;
        }

        const onRendered = ({ name, node, abortController }) => {
            const item = componentPoolByName.get(name);
            if (item) {
                useFetchZone({
                    src: src,
                    root: node,
                    onReady: () => { },
                    abortController
                })
            }
        }


        // componentPoolBySrc.set(src, {
        //     component,
        //     src,
        //     name
        // });

        // componentPoolByName.set(name, {
        //     component,
        //     src,
        //     name
        // });
        const c = newComponent(name, onRendered);

        // const { onCustomComponentRendered } = useCustomComponentRendered(name);

        // onCustomComponentRendered(onRendered)
    }

    return () => ({
        defineComponent: (param) => {
            if (Array.isArray(param)) {
                for (let k in param) {
                    defineComponent(param[k]);
                }
            } else {
                defineComponent(param);
            }
        }
    })
})();

export default useCustomComponent;